import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

import { ContactPersonRole } from '@ordersnproducts/modules/order-builder/modules/location-specification/models/order-management/contact-person-role.model';
import * as fromContactPersonAction from '@ordersnproducts/modules/new-modify-order/modules/new-modify-product-specification/actions/contact-person.action';

export interface State extends EntityState<ContactPersonRole> {
  selectedContactPersonRoleId: number | null;
}

export const adapter: EntityAdapter<ContactPersonRole> = createEntityAdapter<ContactPersonRole>({
  selectId: ($contactPersonRole: ContactPersonRole) => $contactPersonRole.contactPersonRoleId,
  sortComparer: false,
});

const initialState: State = adapter.getInitialState({
  selectedContactPersonRoleId: null,
});

export function reducer(state = initialState, action: fromContactPersonAction.Actions): State {
  switch (action.type) {
    case fromContactPersonAction.ActionTypes.FETCH_ROLES: {
      return state;
    }
    case fromContactPersonAction.ActionTypes.STORE_ROLES: {
      return adapter.addMany(action.payload, adapter.removeAll(state));
    }
    case fromContactPersonAction.ActionTypes.CLEAR_ROLES: {
      return adapter.removeAll(state);
    }
    case fromContactPersonAction.ActionTypes.SET_ROLE: {
      return { ...state, selectedContactPersonRoleId: action.payload };
    }
    default: {
      return state;
    }
  }
}

export const getSelectedContactPersonRoleId = ($state: State) => $state.selectedContactPersonRoleId;

export const getRolesEntities = (state: State) => state.entities;

export const getContactPersonRoles = (state: State) => {
  const roles: ContactPersonRole[] = Object.keys(state.entities).map(i => state.entities[i]);
  return roles;
};
